import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

import SimpleIcon from '@/layouts/AppLayoutHeader/components/SimpleIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownMenuItem',
  props: {
  icon: { type: String, default: '' },
  textMode: { type: Boolean, default: true },
  disabled: { type: Boolean, default: false },
},
  emits: ['click'],
  setup(__props, { emit: emits }) {

const props = __props;





const handleClick = () => {
  if (props.disabled) {
    return
  }

  emits('click')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: handleClick,
    class: _normalizeClass(['dropdown-menu-item', { disabled: props.disabled }])
  }, [
    _renderSlot(_ctx.$slots, "before", {}, () => [
      (props.icon)
        ? (_openBlock(), _createBlock(SimpleIcon, {
            key: 0,
            name: props.icon
          }, null, 8 /* PROPS */, ["name"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({ 'dropdown-menu-item-text': props.textMode })
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2 /* CLASS */),
    _renderSlot(_ctx.$slots, "after")
  ], 2 /* CLASS */))
}
}

})